import styled from 'styled-components/macro';

export const StyledEmptyPage = styled.div`
    padding: 50px 0;
`;
